import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { PAGE_TYPES } from '@sparefoot/tracking-events';
import withSearchHandler from 'decorators/withSearchHandler';
import { Page } from 'components/core/Page';
import { PSPLayout } from 'components/psp/PSPLayout';
import './SizeGuidePage.scss';
import { sizeGuideContent } from 'pages/SizeGuidePage/SizeGuideContent';
import { PSPSearchBar } from 'components/psp/PSPSearchBar';
import withPageViewTracking from '../../components/core/library/tracking-utils/tracking/withPageViewTracking';
import { Schema } from '@sparefoot/react-commons';
import BreadCrumbs from '../../components/organisms/BreadCrumbs/BreadCrumbs';
import Crumb from '../../components/molecules/Crumb/Crumb';
import {
	buildSizeGuideMainPageWebPageSchema,
	buildSGPMainSizeGuidePageSchema,
	buildSGPWebsiteSchema,
} from 'pages/PSPPage/utils/buildSchema';

export const enhance = compose(
	withSearchHandler,
	withPageViewTracking(PAGE_TYPES.PSP),
);

const crumbs = [
	{ href: '/', key: 'home', label: 'Home', name: 'Home', isLast: false },
	{
		href: '/storage-unit-size-guide.html',
		key: 'size-guide',
		label: 'Storage Unit Size Guide',
		name: 'Storage Unit Size Guide',
		isLast: true,
	},
];

// Stringified WebPage schema for PSPLayout (avoids duplicate WebPage from withWebPageSchema decorator)
const SIZE_GUIDE_WEB_PAGE_SCHEMA = JSON.stringify(
	buildSizeGuideMainPageWebPageSchema()
);
const SIZE_GUIDE_WEB_SITE_SCHEMA = JSON.stringify(
	buildSGPWebsiteSchema()
);

export function SizeGuidePage({ handleSearch }) {
	const guideSchema = buildSGPMainSizeGuidePageSchema();

	return (
		<Page
			className="psp-page"
			pageType={PAGE_TYPES.SIZE_LANDING}
		>
			<Schema schema={guideSchema} />
			<PSPSearchBar handleSearch={handleSearch} />
			<PSPLayout
				handleSearch={handleSearch}
				content={sizeGuideContent}
				pageType="size-guide"
				disableJumpSection
				pageSchema={SIZE_GUIDE_WEB_PAGE_SCHEMA}
				siteSchema={SIZE_GUIDE_WEB_SITE_SCHEMA}
			/>
			<BreadCrumbs
				pageType="sgp"
				crumbs={crumbs.map((item) => (
					<Crumb
						key={item.key}
						href={item.href}
						label={item.label}
						isLast={item.isLast}
						name={item.name}
					/>
				))}
			/>
		</Page>
	);
}

SizeGuidePage.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	storageCalculatorUrl: PropTypes.string,
};

export default enhance(SizeGuidePage);
